
import Vue from "vue";
import { IInvoiceData } from "../types";
import InvoiceTableRow from "@/components/InvoiceTableRow.vue";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";

export default Vue.extend({
  name: "invoice-table",
  mixins: [AppPropsMixin],
  components: { InvoiceTableRow },
  props: {
    invoices: { type: Array as () => IInvoiceData[] }
  }
});
